import {BLOGS_CONSTS} from "../constants";

export const initialState = {
    blogs: [],
    blogsCategory: [],
    blogById: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case BLOGS_CONSTS.GET_BLOG:

            return {
                ...state,
                blogs: {
                    blogList: action.payload.data,
                    hasMore: action.payload.hasMore,
                },
            };
        case BLOGS_CONSTS.GET_BLOG_CATEGORY:

            return {
                ...state,
                blogsCategory: action.payload,
            };
        case BLOGS_CONSTS.GET_BLOG_BY_ID:

            return {
                ...state,
                blogById: action.payload[0],
            };

        default:
            return state;
    }
}
